<template>
  <w-flex justify-center align-center >
    <div class="w-card__content content-hardcode">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess" >
        <w-flex class="mt3">
          <div class="xs11">
            <z-input
                label="Profil *"
                name="profil_id"
                readonly
                v-model="form.name"
                @click="profil"
                :validators="[validators.required]"
            />
          </div>
          <div class="xs1">
              &nbsp;
              <w-icon @click="dialog.show = true"
                  >fal fa-plus</w-icon
              >
          </div>
        </w-flex>
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input  class="mt4" label="No Tangki *" type="text" v-model="form.no_tangki" :validators="[validators.required]"/>
            <w-input class="mt4"  label="Bilik *" type="text" v-model="form.ruangan" :validators="[validators.required]"/>
            <w-input class="mt4" label="Rak *" type="text" v-model="form.rak" :validators="[validators.required]"/>
            <w-input class="mt4" label="Aras " type="text" v-model="form.level" />
            <w-input class="mt4" label="Slot " type="text" v-model="form.slot" />
            
          </div>
          <div class="mx2"></div>
          <div class="grow " >
            <h1></h1>
            <z-select class="mt4" label="Jenis *" v-model="form.jenis" :items="jenis" :validators="[validators.required]"/>
            <w-input class="mt4" label="Tarikh *" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <w-input class="mt4" label="Kapasiti (Straw)" type="number" v-model="form.kapasiti" />
            <w-input class="mt4" label="Isipadu Nitrogen (ml)*" type="number" v-model="form.volume" />
            <z-money class="mt4" label="Amaun " v-model:originalValue="form.amaun" name="amaun" :validators="[validators.required]" /> 
            <z-select v-if="form.id>0" class="mt4" :items="lkp_status" label="Status *"  v-model="form.lkp_status_id"  :validators="[validators.required]"/>
          </div>

        </div>
        <w-flex class="mt3" wrap align-center justify-end>
          <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
              <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
          </w-button>
        </w-flex>
      </w-form>
    </div>
  </w-flex>
  <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         KEMASKINI
      </template>

      <w-form 
         ref="form" 
         v-model="dialog.valid"
         @validate="submit"
         @success="success"
      >
          <w-flex justify-center align-center>
              <div class="xs8">
                  <w-input
                      label="No id | Nama"
                      v-model="carian_profil.q"
                  >
                  </w-input>
              </div>
              <div class="xs4">
                  <w-button class="ml1" @click="cariProfil">Cari</w-button>

                  <w-button 
                      class="ml1" 
                      @click="tambahPrfile()"
                      >
                      Tambah
                  </w-button>
              </div>
          </w-flex>
        <div class="w-table-wrap" style="max-height: 400px;">
          <div class="table-profil-scrol">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-left" width="1%">No</th>
                <th class="w-table__header  text-left">Nama</th>
                <th class="w-table__header  text-left">Email</th>
                <th class="w-table__header  text-left">Alamat</th>
                <th class="w-table__header  text-left">Pilih</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="user_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in user_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" >{{dt.no_id}} | {{dt.label}}</td>
                  <td class="w-table__cell text-left" >{{dt.email}}</td>
                  <td class="w-table__cell text-left" >{{dt.alamat}}</td>
                  <td class="w-table__cell text-center">
                    <template v-if="form.pembekal_id == dt.value">
                       <w-radio
                        class="mr2"
                        v-model="form.pembekal_id"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>
                    <template v-else>
                      <w-radio
                        class="mr2"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>

                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
      </w-form>
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      </template>
  </w-dialog>
  <w-dialog
      v-model="dialog_add.show"
      :fullscreen="dialog_add.fullscreen"
      :width="dialog_add.width"
      :persistent="dialog_add.persistent"
      :persistent-no-animation="dialog_add.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Tambah profil
      </template>

      <w-form 
         ref="form" 
         v-model="dialog_add.valid"
         @validate="submitProfil"
         @success="success"
      >
      <div class="spacer"></div>
        <w-flex wrap :gap="2">
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="No. Kad Pengenalan *"
           class="mt3"
           type="text"
           placeholder="No. Kad Pengenalan"
           name="no_id"
           v-model="form_profil.no_id"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
            outline
            label="Emel *"
            class="mt3"
            type="email"
            placeholder="Sila Masukkan Emel"
            name="email"
            v-model="form_profil.email"
            :validators="[validators.required, validators.email]"
         />
          </div>
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="Nama Penuh *"
           class="mt3"
           type="text"
           placeholder="Nama Penuh"
           name="name"
           v-model="form_profil.name"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
             outline
             label="Nombor Telepon *"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Nombor Telefon"
             name="no_tel"
             v-model="form_profil.no_tel"
             :validators="[validators.required, validators.numeric]"
         />
          </div>
        </w-flex>
        <div class="spacer"></div>
        <w-textarea 
            outline 
            label="Alamat*"
            placeholder="Sila Masukkan Alamat"
            class="mt3"
            name="alamat"
            v-model="form_profil.alamat"
            type="text-area"
            :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <template v-if = "form.p == 1">
         <z-select 
            outline
            :items="poskod" 
            label="Poskod"  
            v-model="form.lkp_poskod_id"
            @input="checkPoskod()"
            />
        </template>
        <template v-else>
          <w-input
             outline
             label="Poskod"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Poskod"
             name="poskod"
             v-model="form_profil.kode"
             @change="getPoskodUtama()"
             :validators="[validators.required, validators.numeric]"
         />
        </template>
        <br>
        <z-select 
            outline
            :items="bandar" 
            label="Bandar *"  
            v-model="form_profil.lkp_bandar_id"
            @input="getPoskod(1)"
            :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <z-select 
            outline
            :items="negeri" 
            label="Negeri *"  
            v-model="form_profil.lkp_negeri_id"
            @input="getBandar(1)"
            :validators="[validators.required]"/>
      </w-form>
        

    
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_add.show = false">TUTUP</w-button>
         <w-button 
         class="ml1" 
         :loading="dialog_add.loading"
         :disabled="dialog_add.valid === false"
         @click="$refs.form.validate()"
         >
           SIMPAN
         </w-button>
      </template>
   </w-dialog>

</template>

<script>
export default {
  name: "Semen",
  props:{
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tangki',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Tangki Nitrogen', route: '/tangki' },
      ],
      title : 'Tambah Tangki',
      form_profil: [],
      form : {
        id : 0,
        no_tangki: '',
        ruangan:'',
        rak:'',
        level:'',
        slot:'',
        tarikh:'',
        kapasiti:'',
        volume:'',
        jenis: '',
        amaun: 0,
        pembekal_id: '',
        name: '',
        p : 0,
      },
      dialog: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
      },
      dialog_add: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
         item: {name: '', email: '', mobile: ''}
      },
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      user_list:[],
      lkp_status: [],
      jenis:[
        {value: 1, label: "Semen & Sel Telur"},
        {value: 2, label: "Embrio"}
      ],
      lkp_status : [],
      jantina : [],
      carian_profil: { q: "" },
      country : [],
      bandar : [],
      negeri : [],
      poskod : [],
      negara : [],
      peran : [],
      jenis_pengguna : [],
      cawangan: [],

    }
  },
  methods:{
    getCawangan(){
      this.$zcomm.get(this.api_service + 'lookup/cawangan', {}).then(res => {
        this.cawangan = res
      })
    },

    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.negara = res
      })
    },
  
    getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
         this.negeri = res
      })
    },

    getBandar(item){
      if (item == 2) {
        this.form_profil.lkp_poskod_id = '';
        this.form_profil.lkp_bandar_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
      if(item == 0){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
    },

    getPoskod(item){
      if (item == 2 || this.form_profil.lkp_bandar_id == '') {
      this.form_profil.lkp_poskod_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
      this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form_profil.lkp_bandar_id, {}).then(res => {
        this.poskod = res
      })
      }
    },

    getPoskodUtama(){
      this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form_profil.kode, {}).then(res => {
        // this.form.p = res.p
        this.form_profil.lkp_negeri_id = res.lkp_negeri_id
        this.form_profil.lkp_bandar_id = res.lkp_bandar_id
        this.form_profil.lkp_poskod_id = res.lkp_poskod_id
        this.getPoskod(0)
        this.getBandar(0)
      })
    },

    checkPoskod(){
      if(this.form_profil.lkp_poskod_id == null){
         this.form_profil.p = 0
      }
    },
    tambahPrfile(){
      this.form_profil = {
           id : null,
           no_id : null,
           name : null,
           email:'',
           no_tel: '',
           alamat: '',
           password: 123123,
           pembekal: 1,
           status : 1,
           kode: '',
           lkp_poskod_id: '',
           lkp_bandar_id : '',
           lkp_negeri_id :'',
      }
      this.dialog_add.show = true
      this.form_profil.saveButton = "Save"
    },
    submitProfil(){
      this.$zcomm.post('pengguna',this.form_profil).then(res => {
          if (res == "No. Kad Pengenalan sudah wujud!" || res == "Email sudah wujud!") {
            if (res == "No. Kad Pengenalan sudah wujud!")
                {
                  this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
                }
            if (res == "Email sudah wujud!")
                {
                  this.$zutil.notify("Email sudah wujud!", false);
                }
          }else{
            this.$zutil.notify("Berjaya disimpan");
            this.getUserList();
            this.dialog_add.show = false;
          }
        })
        .catch(err => {
        })
    },
    pengguna(){
      this.getUserList();
      this.dialog.show = true
      this.form.saveButton = "Save"
    },
    pilihProfil(dt) {
        this.form.pembekal_id = dt.value;
        this.form.name = dt.label;
        this.dialog.show = false
    },

    cariProfil() {
        if (this.carian_profil.q.length > 1) {
            this.$zcomm
                .get(
                    this.api_service + "lookup/user_list/1",
                    this.carian_profil,
                    {}
                )
                .then((res) => {
                    this.user_list = res;
                });
        }
    },

    getUserList(){
      this.$zcomm.get(this.api_service + 'lookup/user_list/1', {}).then(res => {
        this.user_list = res
      })
    },
    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
        this.lkp_status = res
      })
    },
    onSuccess(){
      if (this.form.id > 0) 
      {
        this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
        .then(res => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$inertia.visit(this.$route('tangki.show', this.form.id))
        })
      }
      else 
      {
        this.$zcomm.post(this.resourceurl+'.store' , this.form)
        .then(res => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
          }
          this.$inertia.visit(this.$route('tangki.show', res.id))

        })
      }
    },
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'tangki/show/'+this.id, {}).then(res => {
          this.form = res

        })
      }
    },
    
  },
      
  mounted() {
    this.getNegeri();
    this.getStatus()
    this.getUserList()
    this.getData();
  }
}
      

</script>  
